import { apiPost } from "./client";
import type { Opportunity } from "@sales-ops-amplify/shared";

export interface IntakeImportResult {
  created: Opportunity[];
  skipped: number;
  total?: number;
}

export interface ApolloLead {
  company: string;
  dealName: string;
  url?: string;
  brief?: string;
  leadName?: string;
  contactEmail?: string;
  contactTitle?: string;
  linkedinUrl?: string;
}

export async function importCsv(
  csv: string,
  columnMap?: Record<string, string>,
): Promise<IntakeImportResult> {
  return apiPost("/api/intake/csv", { csv, columnMap });
}

export async function searchApollo(params: {
  q_organization_name?: string;
  person_titles?: string[];
  person_locations?: string[];
  page?: number;
  per_page?: number;
}): Promise<{ leads: ApolloLead[]; total: number }> {
  return apiPost("/api/intake/apollo/search", params);
}

export async function importApollo(leads: ApolloLead[]): Promise<IntakeImportResult> {
  return apiPost("/api/intake/apollo/import", { leads });
}

export async function importSalesNav(csv: string): Promise<IntakeImportResult> {
  return apiPost("/api/intake/salesnav/import", { csv });
}
